import React from "react";
import { Table, Modal, Form, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import { API_URL } from "../../constants/Globals";
import { saveSelectedGroup } from "../../redux/action/networks.action";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons";

class Organizations extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      searchText: "",
      order: "",
      orderBy: "title",
      showAddOrganizationModal: false,
      allOrganizations: "",
      organizationFormData: {
        name: "",
        allowedNetworks: "",
      },
      currentEditingOrganizationId: "",
      currentEditedGroupName: "",
      sortBy: "name",
      sortOrder: "ASC",
    };
  }

  fetchAllOrganizations = async (e) => {
    await this.setState({
      loading: true,
    });
    await axios
      .get(
        API_URL + "/admin/groups/getGroups?sortBy=" + this.state.sortBy + "&sortOrder=" + this.state.sortOrder + "&searchText=" + this.state.searchText
      )
      .then((res) => {
        this.setState({
          allOrganizations: res.data.data,
          loading: false,
        });
        this.hideEditOrganizationNameField();
      })
      .catch((err) => {
        alert("Failed. Please try again!");
        console.log(err);
        this.setState({
          loading: false,
        });
      });
  };

  componentDidMount = () => {
    this.fetchAllOrganizations();
  };

  handleSearchSubmit = async (e) => {
    this.fetchAllOrganizations();
    e.preventDefault();
  };
  handleQueryChange = async (e) => {
    this.setState({ searchText: e.target.value });
  };

  showAddOrganizationModal = async () => {
    this.setState({
      showAddOrganizationModal: true,
    });
  };

  hideAddOrganizationModal = async (e) => {
    await this.setState({
      showAddOrganizationModal: false,
    });

    var organizationFormData = { ...this.state.organizationFormData };
    organizationFormData["name"] = "";
    await this.setState({ organizationFormData });
  };
  organizationFormChangeHandler = async (e) => {
    var organizationFormData = { ...this.state.organizationFormData };
    organizationFormData[e.target.name] = e.target.value.trimLeft();
    await this.setState({ organizationFormData });
  };

  submitAddOrganizationHandler = async (e) => {
    e.preventDefault();
    await this.setState({
      loading: true,
    });
    await axios
      .post(API_URL + "/admin/groups/create", this.state.organizationFormData)
      .then((res) => {
        this.fetchAllOrganizations();
        this.messageNotification(
          "success",
          this.props.t("Network organization created successfully!")
        );
        this.hideAddOrganizationModal();
      })
      .catch((err) => {
        alert(err.response.data.message[0].name);
        console.log(err.response.data);
        this.setState({ loading: false });
      });
  };

  messageNotification = async (type, message) => {
    this.setState({
      successMsg: message,
    });

    setTimeout(() => {
      this.setState({
        successMsg: "",
      });
    }, 5000);
  };

  showEditOrganizationNameField = async (e, groupId, groupName) => {
    this.setState({
      currentEditingOrganizationId: groupId,
      currentEditedGroupName: groupName,
    });
  };

  hideEditOrganizationNameField = async (e) => {
    this.setState({
      currentEditingOrganizationId: "",
      currentEditedGroupName: "",
    });
  };

  organizationNameChangeHandler = async (e) => {
    this.setState({
      currentEditedGroupName: e.target.value,
    });
  };
  saveEditOrganizationNameField = async (e, groupId) => {
    e.preventDefault();
    await this.setState({
      loading: true,
    });
    await axios
      .post(API_URL + "/admin/groups/updateGroup/" + groupId, {
        groupName: this.state.currentEditedGroupName,
      })
      .then((res) => {
        this.fetchAllOrganizations();
        this.messageNotification(
          "success",
          this.props.t("Group name updated successfully!")
        );
      })
      .catch((err) => {
        alert(err.response.data.message[0].name);
        console.log(err.response.data);
        this.setState({ loading: false });
      });
  };

  handleOrganizationChange = async (e, groupSlug) => {
    await this.props.saveSelectedOrganization(groupSlug);
  };

  render() {
    const loggedInUser = this.props.loggedInUser;
    const isSuperAdmin =
      loggedInUser &&
      loggedInUser.roles &&
      loggedInUser.roles.find((role) => role.name === "SUPERADMIN");
    const {
      loading,
      allOrganizations,
      currentEditingOrganizationId,
      currentEditedGroupName,
    } = this.state;
    const { name, allowedNetworks } = this.state.organizationFormData;
    const kTrans = this.props.t ? this.props.t : "";

    return (
      <section className={loading === true ? "loading" : ""}>
        {this.state.successMsg ? (
          <div className="sucessMsg">{this.state.successMsg}</div>
        ) : null}
        <div className="inline-content top title-section mb-2">
          <h2>{kTrans("Network Organizations")}</h2>
          {loggedInUser &&
          loggedInUser.roles &&
          loggedInUser.roles.length > 0 &&
          loggedInUser.roles.find((role) => role.name === "SUPERADMIN") ? (
            <span
              onClick={this.showAddOrganizationModal}
              className="btn btn-primary"
            >
              + {kTrans("Add Organization")}
            </span>
          ) : null}
        </div>
        <h3 className="mb-4">{kTrans("All Organizations")}</h3>
        <div className="mb-3">
          <form
            id="search"
            autoComplete="off"
            className="navbar-form navbar-left w-25"
            method="get"
            onSubmit={this.handleSearchSubmit}
          >
            <input
              onChange={this.handleQueryChange}
              type="text"
              className="form-control"
              value={this.state.searchText}
              name="searchText"
              placeholder={kTrans("Search")}
            />
            <button type="submit">
              <i className="fa fa-search"></i>
            </button>
          </form>
        </div>

        <p>
          <small>
            <strong>
              {kTrans("Result")}
              {allOrganizations.length === 0 || allOrganizations.length > 1
                ? "s"
                : ""}
              : {allOrganizations.length}
            </strong>
          </small>
        </p>
        <div className="table-wrapper">
          <Table className="networks tableCommon organizationNetworksTable">
            <thead>
              <tr>
                <th className="w-50">{kTrans("ORGANIZATION NAME")}</th>
                <th>{kTrans("NETWORKS")}</th>
                <th>{kTrans("ORGANIZATION USERS")}</th>
                {isSuperAdmin ? (
                  <th>{kTrans("Organization SETTINGS")}</th>
                ) : null}
              </tr>
            </thead>
            <tbody>
              {allOrganizations && allOrganizations.length ? (
                allOrganizations.map((el, i) => (
                  <tr id={el.groupId} key={el.groupId}>
                    <td className="d-flex align-items-baseline">
                      {currentEditingOrganizationId &&
                      currentEditingOrganizationId === el.groupId ? (
                        <Form.Group
                          controlId="groupName"
                          className="currentEditedGroupName pt-0 position-relative"
                        >
                          <Form.Control
                            type="text"
                            onChange={(e) => {
                              this.organizationNameChangeHandler(e);
                            }}
                            name="currentEditedGroupName"
                            value={currentEditedGroupName.trimLeft()}
                            placeholder={kTrans("Enter the organization name")}
                          />
                          <div className="editOrganizationNameBtns">
                            <span
                              className="cancel me-3 customAnchor light"
                              onClick={this.hideEditOrganizationNameField}
                            >
                              {kTrans("Cancel")}
                            </span>
                            <span
                              className="save customAnchor"
                              onClick={(e) =>
                                this.saveEditOrganizationNameField(
                                  e,
                                  el.groupId
                                )
                              }
                            >
                              {kTrans("Save")}
                            </span>
                          </div>
                        </Form.Group>
                      ) : (
                        <>
                          <strong>{el.groupName}</strong>
                          {el.groupName !== "Sided" ? (
                            <svg
                              onClick={(e) =>
                                this.showEditOrganizationNameField(
                                  e,
                                  el.groupId,
                                  el.groupName
                                )
                              }
                              className="ms-2"
                              width="40"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.4 2.8H0V12.6C0 13.377 0.63 14 1.4 14H11.2V12.6H1.4V2.8ZM11.69 3.745L10.99 4.445L9.555 3.01L10.255 2.31C10.402 2.156 10.647 2.156 10.794 2.31L11.69 3.206C11.844 3.353 11.844 3.598 11.69 3.745ZM4.9 7.658L9.142 3.416L10.584 4.858L6.342 9.1H4.9V7.658ZM12.6 1.4V9.8H4.2V1.4H12.6ZM12.6 0H4.2C3.43 0 2.8 0.63 2.8 1.4V9.8C2.8 10.57 3.43 11.2 4.2 11.2H12.6C13.37 11.2 14 10.57 14 9.8V1.4C14 0.63 13.37 0 12.6 0Z"
                                fill="#43A5F5"
                              />
                            </svg>
                          ) : null}
                        </>
                      )}
                    </td>
                    <td>
                      {el.networkCount}{" "}
                      <NavLink
                        onClick={(e) =>
                          this.handleOrganizationChange(e, el.groupSlug)
                        }
                        className="customAnchor d-inline-block"
                        to={`organizations/${el.groupSlug}/networks`}
                      >
                        &nbsp;{kTrans("View")}
                      </NavLink>
                    </td>
                    <td>
                      {el.organizationUsersCount}{" "}
                      <NavLink
                        onClick={(e) =>
                          this.handleOrganizationChange(e, el.groupSlug)
                        }
                        className="customAnchor d-inline-block"
                        to={`/organizations/${el.groupSlug}/users`}
                      >
                        &nbsp;{kTrans("View")}
                      </NavLink>
                    </td>
                    {isSuperAdmin ? (
                      <td>
                        <NavLink
                          onClick={(e) =>
                            this.handleOrganizationChange(
                              e,
                              el.groupSlug
                            )
                          }
                          className="customAnchor d-inline-block"
                          to={`/organizations/${el.groupSlug}/settings`}
                        >
                          &nbsp;{kTrans("View")}
                        </NavLink>
                      </td>
                    ) : null}
                    <td>
                      <NavLink
                          onClick={(e) =>
                            this.handleOrganizationChange(e, el.groupSlug)
                          }
                          className="customAnchor d-inline-block"
                          to={`/organizations/${el.groupSlug}/organization-settings?groupId=${el.groupId}`}
                        >
                        <FontAwesomeIcon
                          icon={faCog}
                          className="svg settings"
                          // onClick={(e) =>
                          //   alert('Open setting page....')
                          // }
                        />
                      </NavLink>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">
                    <h3 className="text-center">{kTrans("No Group Found")}</h3>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        <Modal
          className="addOrganizationModal"
          size="lg"
          show={this.state.showAddOrganizationModal}
        >
          <Modal.Header>
            <Modal.Title>{kTrans("Add Organization")}</Modal.Title>
            <span className="modal-close-btn">
              <b className="" onClick={this.hideAddOrganizationModal}>
                &#x2715;
              </b>
            </span>
          </Modal.Header>
          <Modal.Body className={loading === true ? "loading" : ""}>
            <div className="modalContentWrapper">
              <Form
                className="AddOrganizationForm common-form pe-md-5 ps-md-5"
                onSubmit={this.submitAddOrganizationHandler}
              >
                <Form.Group controlId="groupName" className="pt-0">
                  <Form.Label>{kTrans("ORGANIZATION NAME")}</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => {
                      this.organizationFormChangeHandler(e);
                    }}
                    name="name"
                    value={name}
                    placeholder={kTrans("Enter the organization name")}
                  />
                </Form.Group>
                <Form.Group controlId="allowedNetworks" className="mb-2 mt-2">
                  <Form.Label>{kTrans("ALLOWED NETWORKS COUNT")}</Form.Label>
                  <Form.Control
                    type="number"
                    onChange={(e) => this.organizationFormChangeHandler(e)}
                    name="allowedNetworks"
                    value={allowedNetworks}
                    placeholder={kTrans("Enter allowed networks count")}
                    min="0"
                  />
                </Form.Group>
                <div className="buttons text-center">
                  <Button
                    className="mt-2"
                    onClick={this.hideAddOrganizationModal}
                    variant="secondary"
                  >
                    {kTrans("Cancel")}
                  </Button>
                  <Button
                    className={`mt-2 ${name === "" ? "disabled" : ""}`}
                    variant="primary"
                    type="submit"
                  >
                    {kTrans("Create Organization")}
                  </Button>
                </div>
              </Form>
            </div>
          </Modal.Body>
        </Modal>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  loggedInUser: state.login.user,
});

const Extended = withTranslation()(Organizations);
Extended.static = Organizations.static;

export default connect(mapStateToProps, { saveSelectedGroup })(Extended);
